import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";

export const lastSetIpynbMs = (
  _state: number,
  action: NotebookAction
): number => {
  switch (action.type) {
    case NotebookActionKey.SET_DRAFT_SPEC:
      return Date.now();
    case NotebookActionKey.SET_IPYNB:
      return Date.now();
    default:
      return Date.now();
  }
};
